import React from 'react';
// import socketio from 'socket.io-client';
import { io } from 'socket.io-client';

export const socket = io('/', {
  reconnection: true,
  reconnectionDelay: 1000,
  maxReconnectionAttempts: Infinity,
  auth: (cb) => {
    cb({ token: localStorage.token || '' });
  },
});
export const SocketContext = React.createContext();
